import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { OrganizationDetailDataObject } from 'models/service';

export const joinOrganization = async ({ id }: { id: string }) =>
  apiClient.post<OrganizationDetailDataObject, ApiClientResponse<OrganizationDetailDataObject>>(
    routes.organizations.join(id),
  );
